export default "__VITE_ASSET__Wnd3Ddbg__"